





















































import { Component, Prop, Vue } from 'vue-property-decorator'
import { GamificationSettings } from '@/api/model/gamification-settings'
import { BadgeColor, BadgeType, BadgeTypes } from '@/api/types'

@Component
export default class EditGamificationSettingsForm extends Vue {
    @Prop({ required: true }) gamificationSettings!: GamificationSettings

    selectedBadges = []

    mounted() {
        this.selectedBadges = this.gamificationSettings.activatedBadges
    }

    isActive(type: string): boolean {
        return this.selectedBadges.includes(type)
    }

    activeColor(type: string): string {
        return this.isActive(type) ? BadgeColor.GREEN : BadgeColor.SILVER
    }

    classes(type: string): object {
        return {
            'badge-button': true,
            'badge-button--active': this.isActive(type),
        }
    }

    toggleActive(type: string): void {
        if (this.isActive(type)) {
            this.selectedBadges.splice(this.selectedBadges.indexOf(type), 1)
        } else {
            this.selectedBadges.push(type)
        }

        this.gamificationSettings.activatedBadges = this.selectedBadges
    }

    get BadgeTypes(): string[] {
        if (this.$currentCompany.pipelinesEnabled) {
            return BadgeTypes.filter(type => type !== BadgeType.MOST_PROPOSALS)
        }

        return BadgeTypes
    }
}
